/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSecureTokenRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/client_service.pb'
import {GetSecureTokenResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/client_service.pb'


export const getSecureToken = (request:GetSecureTokenRequest, options?: CashRequestOptions) => post<GetSecureTokenRequest, GetSecureTokenResponse>("/2.0/cash/get-secure-token", request, {...options, rejectOnError: true })